<div *ngIf="company && company.bondRequest">
  <div class="row mb-3">
    <div *ngIf="!poaDocument" class="col-12 label">{{ "COMPANY.BOND_PURCHASE_PLEASE_UPLOAD_POA" | translate }}</div>
    <div class="col-12 value">
      <div class="mt-2">
        <document-upload-desktop
          [id]="'company-poa-upload-form'"
          [uploadedDocument]="poaDocument"
          [attachmentName]="'DOCUMENT_TYPE.POWER_OF_ATTORNEY'"
          [attachmentHint]="'COMPANY.BOND_PURCHASE_PLEASE_UPLOAD_POA'"
          [isRequired]="true"
          [canUploadDocuments]="true"
          [canRemoveDocuments]="false"
          [isLoading]="isLoadingCompanyPoa"
          [isStretched]="true"
          (upload)="uploadPoa($event)"
          (stateUpdate)="updateDocumentState($event)"
        ></document-upload-desktop>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "FORM_LABEL.FULL_COMPANY_NAME" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.companyName }}</div>
    <ng-template [ngIf]="isNotMatchedCompanyName && isCanEdit">
      <div
        class="col-12 text-warning helper"
        [innerHTML]="'COMPANY.BOND_REQUEST.NOT_MATCHED_COMPANY_NAME' | translate : { businessName: company.businessName }"
      ></div>
      <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn-link mr-3" (click)="setCompanyBusinessName()">
          {{ "BUTTON.SET_COMPANY_BUSINESS_NAME" | translate }}
        </button>
        <button type="button" class="btn btn-link" [routerLink]="['/companies', 'update']">
          {{ "BUTTON.UPDATE_COMPANY" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "LABELS.BUSINESS_TYPE" | translate }}</div>
    <div class="col-12 col-md-6 value">
      <ng-template [ngIf]="businessTypeLabel">
        {{ "BUSINESS_TYPE." + businessTypeLabel | translate }}
      </ng-template>
    </div>
    <ng-template [ngIf]="isNotMatchedCompanyBusinessType && isCanEdit">
      <div
        class="col-12 text-warning helper"
        [innerHTML]="
          'COMPANY.BOND_REQUEST.NOT_MATCHED_COMPANY_BUSINESS_TYPE'
            | translate : { businessType: 'BUSINESS_TYPE.' + companyBusinessTypeLabel | translate }
        "
      ></div>
      <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn-link mr-3" (click)="setCompanyBusinessType()">
          {{ "BUTTON.SET_COMPANY_BUSINESS_TYPE" | translate }}
        </button>
        <button type="button" class="btn btn-link" [routerLink]="['/companies', 'update']">
          {{ "BUTTON.UPDATE_COMPANY" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "FORM_LABEL.PHYSICAL_ADDRESS" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.address }}</div>
    <ng-template [ngIf]="isNotMatchedCompanyAddress && isCanEdit">
      <div
        class="col-12 text-warning helper"
        [innerHTML]="'COMPANY.BOND_REQUEST.NOT_MATCHED_COMPANY_ADDRESS' | translate : { address: companyAddressLine }"
      ></div>
      <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn-link mr-3" (click)="setCompanyAddress()">
          {{ "BUTTON.SET_COMPANY_ADDRESS" | translate }}
        </button>
        <button type="button" class="btn btn-link" [routerLink]="['/companies', 'update']">
          {{ "BUTTON.UPDATE_COMPANY" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "FORM_LABEL.FEDERAL_TAX_ID_OR_IMPORTER_NUMBER" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.importerNumber }}</div>
    <ng-template [ngIf]="isNotMatchedCompanyIdentifier && isCanEdit">
      <div
        class="col-12 text-warning helper"
        [innerHTML]="
          'COMPANY.BOND_REQUEST.NOT_MATCHED_COMPANY_IDENTIFIER' | translate : { identifier: companyIdentifierValue | identifier }
        "
      ></div>
      <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn-link mr-3" (click)="setCompanyIdentifier()">
          {{ "BUTTON.SET_COMPANY_IDENTIFIER" | translate }}
        </button>
        <button type="button" class="btn btn-link" [routerLink]="['/companies', 'update']">
          {{ "BUTTON.UPDATE_COMPANY" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "FORM_LABEL.COMMODITIES_BEING_IMPORTED" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.commodities }}</div>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "FORM_LABEL.COUNTRY_OF_ORIGIN" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.mainCountryOfOriginCode }}</div>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "LABELS.ANNUAL_ESTIMATED_VALUE_OF_IMPORTS" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.estimatedImportValue }}</div>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "LABELS.ANNUAL_ESTIMATED_DUTIES_VALUE" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.estimatedDutyValue }}</div>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6 label">{{ "LABELS.STATE_OF_INCORPORATION" | translate }}</div>
    <div class="col-12 col-md-6 value">{{ company.bondRequest.continuousBondDetails.stateOfIncorporationCode }}</div>
  </div>
  <div class="row mb-3">
    <div class="col-12 label">{{ "FORM_LABEL.ARE_COMMODITIES_SUBJECT_TO_ACD" | translate }}</div>
    <div class="col-12 value">
      {{ (company.bondRequest.continuousBondDetails.areCommoditiesSubjectToACD ? "LABELS.YES" : "LABELS.NO") | translate }}
    </div>
  </div>
  <div *ngIf="company.bondRequest.continuousBondDetails.notes" class="row mb-3">
    <div class="col-12 label">{{ "LABELS.NOTES" | translate }}</div>
    <div class="col-12 value">{{ company.bondRequest.continuousBondDetails.notes }}</div>
  </div>
  <div *ngIf="!isPaid || !isSent" class="row mb-3">
    <div class="col-12 helper mb-3" [innerHTML]="'FORM_HELPER.CONTINUOUS_BOND_PURCHASE_SENT' | translate"></div>
    <div class="col-12">
      <div class="form-group d-flex justify-content-between">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="isFormChecked" [formControl]="checkedFormControl" />
          <label class="custom-control-label" for="isFormChecked">
            {{ "FORM_LABEL.DETAILS_CORRECT" | translate }}
          </label>
        </div>
        <button type="button" class="btn btn-link desktop" [routerLink]="['/companies', 'bond-request', 'edit']">
          <i class="fa fa-pencil"></i>
          {{ "BUTTON.EDIT" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isPaid || !isSent" class="row mb-3">
    <div *ngIf="!isPaid" class="col-12 mb-3">
      <card-payment
        [isShowCreditCardsHint]="isHasInstantPayment"
        [referenceNumber]="company.bondRequest.referenceNumber"
        [paymentGroupItems]="paymentBreakdown"
      ></card-payment>
    </div>
    <div class="col-12">
      <div class="d-flex justify-content-center">
        <button
          *ngIf="(isPaid || isOnlyMonthlyPayments) && !isSent"
          type="button"
          class="btn btn-primary"
          [disabled]="!isValid"
          (click)="sentRequest()"
        >
          {{ "BUTTON.SEND" | translate }}
        </button>
        <button *ngIf="!isPaid && !isOnlyMonthlyPayments && !isValid" type="button" class="btn btn-primary" [disabled]="!isValid">
          {{ "BUTTON.PAY_AND_SEND" | translate }}
        </button>

        <payment-button
          [referenceNumber]="company.bondRequest.referenceNumber"
          *ngIf="!isPaid && !isOnlyMonthlyPayments && isValid"
        ></payment-button>
      </div>
    </div>
  </div>
</div>
